import PostFooter from 'components/Blog/Post/PostFooter';
import PostWrapper from 'components/Blog/Post/styled/PostWrapper';

import React from 'react';
import { BlogPostType } from 'types/blogPage';
import Description from './styled/Description';
import Title from './styled/Title';

type Props = {
  data: BlogPostType;
};

const Post = ({ data }: Props) => (
  <PostWrapper>
    <Title>{data.title}</Title>
    <Description light dangerouslySetInnerHTML={{ __html: data.content }} />
    <PostFooter image={data.footerImage} link={data.link} />
  </PostWrapper>
);

export default Post;
